import { getRequirements } from '@/api/requirement';

export const requestGetRequirements = (
  params: IRequirement.IRequest.IGetRequirement,
): Promise<IRequirement.IResponse.IData> => {
  return new Promise((reslove, reject) => {
    getRequirements(params).then((res) => {
      reslove(res);
    }).catch((error) => {
      reject(error.message);
    });
  });
};
